<template>
    <div>
        Bienvenue dans l'assistant de configuration
    </div>
</template>

<script>
export default {};
</script>
